import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import { observer } from "mobx-react";
import {loc} from "../../../core/common/config/locales";
import {PAGE} from "../../../routes";
import {SecuredZzUploadFlatButton, ZzFlatButtonRoute} from "../../../core/components/buttons/buttons";
import {PROJECTS_LIST} from "../../gridsContants";
import {action} from "mobx";
import {uploadAxios} from "../../../core/common/config/axios-config";
import ConfirmationDialog from "../../../core/components/confirmationDialog/confirmationDialog";
import SbToolProjectService from "../../service/projectService";
import AlertDialog from "../../../core/components/alertDialog/alertDialog";

interface ProjectImportResponse {
  projectId? : number
  importErrors : string[]
}


@observer
export default class ProjectsList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Projects`;
  static icon = 'building-o';
  static rootPage = true;
  static protectedPage = true;

  // private submitSaveDialog: ConfirmationDialog;
  // private alertDialog: AlertDialog;

  static fetchData(routerParams) {
    console.log("ProjectsList#fetchData(%s)", PROJECTS_LIST);

    return gridService.fetchGrids(PROJECTS_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(PROJECTS_LIST);
      });
  }

  //  openErrorDialogToContinue = (importRes : ProjectImportResponse) => {
  //   if (importRes.projectId) {
  //     let title = loc.i18n`Do you want to save project with this errors: \n`
  //     title += importRes.importErrors.join("\n");
  //
  //     this.submitSaveDialog.open(success => {
  //       this.redirectToImportedProject(importRes.projectId);
  //     }, cancel => {
  //       SbToolProjectService.deleteProject(importRes.projectId);
  //       window.location.reload();
  //     }, title);
  //   } else {
  //     let title = loc.i18n`Critical errors: \n`
  //     title += importRes.importErrors.join("\n")
  //     this.alertDialog.open(success => {}, title);
  //   }
  // };

  // redirectToImportedProject = (projectId : number) => {
  //   this.context.router.replaceWith('sbToolProjectDetail', {id: projectId});
  //   window.location.reload();
  // };

  // submitSaveDialogRefHandler = comp => this.submitSaveDialog = comp;
  // submitAlertDialogRefHandler = comp => this.alertDialog = comp;

  render() {
    let { params, query } = this.props;
    return (
      <div>
        {/*<AlertDialog ref={this.submitAlertDialogRefHandler} okButtonText="OK"/>*/}
        {/*<ConfirmationDialog okButtonText="Yes, I want to cancel" cancelButtonText={"No, I want to cancel"} ref={this.submitSaveDialogRefHandler}/>*/}
        <GridCompConnected grid={gridService.getOrCreateGrid(PROJECTS_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="sbToolProjectDetail" params={{id: 'new'}} label={loc.i18n`New Project`} permission={PERMISSION.New} securable={PAGE.sbToolProjectDetail}/>

        </GridCompConnected>
      </div>
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/project/projectsList.tsx